import gql from 'graphql-tag';

export const CompanyGroupListQuery = gql`
	query CompanyGroupListQuery(
		$first: Int,
		$cursor: String,
		$orderBy: CompanyGroupOrderBy,
		$orderDesc: Boolean,
		$filter: CompanyGroupFilterInput
	) {
		entities: companyGroups(first: $first, after: $cursor, orderBy: $orderBy, orderDesc: $orderDesc, filter: $filter) {
			edges {
				node {
					id
					localId
					name
					type
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}

	}
`;


